import { createContext, useContext, useState, useEffect } from 'react';
import { useAccount } from 'wagmi';
import api from '../utils/axios';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const { address, isConnected } = useAccount();

	const fetchUserData = async () => {
		if (address) {
			try {
				const response = await api.get(`/user/info?address=${address}`);
				setUser(response.data);
			} catch (error) {
				console.error('Error fetching user data:', error);
			} finally {
				setLoading(false);
			}
		}
	};

	// Function to refresh user data
	const refreshUserData = async () => {
		setLoading(true);
		await fetchUserData();
	};

	useEffect(() => {
		fetchUserData();
	}, [address, isConnected]);

	return (
		<UserContext.Provider value={{ user, loading, refreshUserData }}>
			{children}
		</UserContext.Provider>
	);
};

export const useUser = () => {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error('useUser must be used within a UserProvider');
	}
	return context;
};
